import React, { useState } from "react";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { CgWebsite } from "react-icons/cg";
import { BsGithub, BsPlayCircle } from "react-icons/bs";

// Turns a normal YouTube link into an embed link
function toEmbed(url) {
  const match = url.match(/(?:v=|youtu\.be\/)([\w-]{11})/);
  return match ? `https://www.youtube.com/embed/${match[1]}` : url;
}

// Small buttons style so they stay on one line
const btnStyle = {
  fontSize: "0.8rem",
  padding: "4px 10px",
  whiteSpace: "nowrap",
  display: "inline-flex",
  alignItems: "center",
  gap: "5px",
};

function ProjectCards(props) {
  const [showVideo, setShowVideo] = useState(false);

  return (
    <>
      <Card className="project-card-view">
        <Card.Img variant="top" src={props.imgPath} alt="card-img" />
        <Card.Body>
          <Card.Title>{props.title}</Card.Title>
          <Card.Text style={{ textAlign: "justify" }}>
            {props.description}
          </Card.Text>

          <div
            style={{
              display: "flex",
              flexWrap: "nowrap",
              gap: "8px",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Button
              variant="primary"
              size="sm"
              href={props.ghLink}
              target="_blank"
              style={btnStyle}
            >
              <BsGithub />
              {props.isBlog ? "Blog" : "GitHub"}
            </Button>

            {!props.isBlog && props.demoLink && (
              <Button
                variant="primary"
                size="sm"
                href={props.demoLink}
                target="_blank"
                style={btnStyle}
              >
                <CgWebsite />
                Demo
              </Button>
            )}

            {props.videoLink && (
              <Button
                variant="primary"
                size="sm"
                onClick={() => setShowVideo(true)}
                style={btnStyle}
              >
                <BsPlayCircle />
                Video
              </Button>
            )}
          </div>
        </Card.Body>
      </Card>

      {props.videoLink && (
        <Modal
          show={showVideo}
          onHide={() => setShowVideo(false)}
          size="lg"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>{props.title}</Modal.Title>
          </Modal.Header>
          <Modal.Body style={{ padding: 0 }}>
            <div style={{ position: "relative", paddingTop: "56.25%" }}>
              {/* iframe only renders while open, so the video stops when closed */}
              {showVideo && (
                <iframe
                  src={toEmbed(props.videoLink)}
                  title={props.title}
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    border: 0,
                  }}
                  allow="accelerometer; autoplay; encrypted-media; picture-in-picture"
                  allowFullScreen
                />
              )}
            </div>
          </Modal.Body>
        </Modal>
      )}
    </>
  );
}

export default ProjectCards;